module.exports = __webpack_public_path__ + "static/Pt11-50354a308728d2dae10dd99d9175a1d2.jpg";